import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { IconName } from '../icons';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'cdm-icon',
  standalone: true,
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <mat-icon [svgIcon]="icon()"></mat-icon> `,
  host: {
    '[style.width]': 'normalizedSize()',
    '[style.height]': 'normalizedSize()',
    '[style.fontSize]': 'normalizedSize()',
  },
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        width: 24px;
        height: 24px;
        font-size: 24px;
        color: currentColor;
      }

      mat-icon {
        width: 100% !important;
        height: 100% !important;
        font-size: inherit !important;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: visible;

        &::ng-deep svg {
          width: 100%;
          height: 100%;
          margin: 0;
          display: block;
        }
      }
    `,
  ],
})
export class CdmIcon {
  public readonly icon = input.required<IconName>();
  public readonly size = input<number | string>();

  protected readonly normalizedSize = computed(() => {
    const value = this.size();
    if (value === undefined || value === null) return null;
    return typeof value === 'number' ? `${value}px` : value;
  });
}
